import { useConfirmDialog as useConfirmDialogContext } from '../contexts/ConfirmDialogContext';

export const useConfirmDialog = () => {
  const { openConfirmDialog, closeConfirmDialog } = useConfirmDialogContext();

  return {
    openConfirmDialog,
    closeConfirmDialog,
  };
};
